import { render, staticRenderFns } from "./LottieLoader.vue?vue&type=template&id=7ea974ec&scoped=true"
import script from "./LottieLoader.vue?vue&type=script&lang=js"
export * from "./LottieLoader.vue?vue&type=script&lang=js"
import style0 from "./LottieLoader.vue?vue&type=style&index=0&id=7ea974ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea974ec",
  null
  
)

export default component.exports